import { ImageInfo, SequenceInfo, AnnotationSettings } from './annotation.types';
import { InspectionType } from '../../../shared/models/InspectionType';

export const getAnnotationSettings = (imageInfo: ImageInfo, selectedSequenceInfo: SequenceInfo): AnnotationSettings => {
  return {
    canAnnotate: canBeAnnotated(imageInfo),
    callMLServices: shouldCallMLServices(selectedSequenceInfo),
    localizationEditable: areLocalizationPropertiesEditable(selectedSequenceInfo)
  };
};

const canBeAnnotated = (imageInfo: ImageInfo): boolean => {
  return !(imageInfo.isPhotocard || imageInfo.isDetailed);
};

const shouldCallMLServices = (selectedSequenceInfo: SequenceInfo): boolean => {
  return selectedSequenceInfo.inspectionType !== InspectionType.RopeAccess && selectedSequenceInfo.inspectionType !== InspectionType.Telescope;
};

const areLocalizationPropertiesEditable = (selectedSequenceInfo: SequenceInfo): boolean => {
  return (
    selectedSequenceInfo.inspectionType === InspectionType.RopeAccess ||
    selectedSequenceInfo.inspectionType === InspectionType.Telescope ||
    selectedSequenceInfo.inspectionType === InspectionType.NoMetadata
  );
};

export const shouldShowImageTreeStructure = (selectedSequenceInfo: SequenceInfo): boolean => {
  return selectedSequenceInfo.inspectionType === InspectionType.RopeAccess || selectedSequenceInfo.inspectionType === InspectionType.Telescope;
};
